// SystemTooltip component types

export enum SystemTooltipVariant {
  TOP_LEFT = 'top_left',
  TOP_CENTER = 'top_center',
  TOP_RIGHT = 'top_right',
}

export interface Position {
  top: number;
  left: number;
  actualVariant: SystemTooltipVariant;
}

export interface SystemTooltipProps {
  /** The content to wrap with the tooltip */
  children: React.ReactNode;
  /** The content to display in the tooltip */
  content: string | React.ReactNode;
  /** Positioning variant for the tooltip */
  variant?: SystemTooltipVariant;
  /** Delay in milliseconds before showing the tooltip */
  delay?: number;
  /** Whether the tooltip is disabled */
  disabled?: boolean;
  /** Additional CSS class for the trigger wrapper */
  className?: string;
  /** Additional CSS class for the tooltip content */
  tooltipClassName?: string;
  /** Distance in pixels between trigger and tooltip */
  offset?: number;
}

export interface UseSystemTooltipReturn {
  isVisible: boolean;
  position: Position | null;
  triggerRef: React.RefObject<HTMLElement>;
  tooltipRef: React.RefObject<HTMLElement>;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
}
